function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "icons8-heroku",
  d: "M70.748,2H16.659A9.668,9.668,0,0,0,7,11.659V81.2a9.668,9.668,0,0,0,9.659,9.659h54.09A9.668,9.668,0,0,0,80.407,81.2V11.659A9.668,9.668,0,0,0,70.748,2ZM25.465,77.173V57.953l9.614,9.614Zm36.13.06H52.389V43.48s2.2-8.082-27.045,3.305c-.053.143-.053-31.218-.053-31.218l9.553-.053V35.6S61.6,25.068,61.6,43.594ZM57.83,27.671H47.7c3.652-4.46,6.95-12.1,6.95-12.1H65.127S63.331,20.548,57.83,27.671Z",
  transform: "translate(-7 -2)"
});

function SvgHeroku(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 73.407,
    height: 88.861,
    viewBox: "0 0 73.407 88.861",
    transform: "translate(0 5)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroku);
export default __webpack_public_path__ + "static/media/Heroku.e71504d0.svg";
export { ForwardRef as ReactComponent };